const translations = {
    move: 'Move',
    reassignBoundarySubText:
        '"{{boundaryName}}" is currently assigned to {{fieldName}}. Saving this form will remove that assignment.',
    reassignBoundaryText: 'Move "{{boundaryName}}" to this field?',
    remove: 'Remove',
    unassignLastBoundarySubText: 'This field will have no boundaries.',
    unassignPrimarySubText:
        'The earliest boundary added to this field will automatically become the primary boundary.',
    unassignPrimaryText: 'Remove "{{boundaryName}}" as the primary boundary?',
    unknownField: 'another field'
};

export default translations;
